import React from 'react';

import {
  Row,
  Col,
  Button,
  Layout,
  Modal,
  Breadcrumb,
  Select,
  DatePicker,
} from 'antd/lib';

import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import TablaStockDelDia from './TablaStockDelDia';

import getStockEnFecha from '../../../graphql/querys/ventas/getStockEnFecha.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';

import { imprimirReporteStockFecha } from '../../common/funciones/imprimirReporte';

@compose(
  graphql(getUsuario, {
    name: 'usuario',
  }),
  graphql(getOrganismos)
)
class VerStockDelDia extends React.Component {
  state = {
    loading: false,
    tipo_sellos: [],
    llamada: false,
    fechaInicio: '',
    fechaFin: '',
    idOrganismo:
      this.props.usuario && this.props.usuario.organismo
        ? this.props.usuario.organismo._id
        : '',
    step: 0,
    fecha: moment(),
  };

  // onSubmit = e => {
  //   e.preventDefault();
  //   // console.log(e);
  //   this.buscar();
  //   fecha;
  // };

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log('NEXTPROPS: ', nextProps);
    // console.log('STATE: ', this.state);
    if (
      nextProps.usuario &&
      !nextProps.usuario.loading &&
      !this.state.llamada
    ) {
      this.cambiarDatos(
        nextProps.usuario.getUsuario.organismo._id,
        this.state.fecha
      );
    }
  }

  // componentDidMount() {
  //   console.log('THIS PROPS: ', this.props);
  //   this.cambiarDatos(this.props.usuario.getUsuario.organismo._id, this.state.fecha);
  // }

  disabledDate = fecha => {
    return fecha && fecha > moment().endOf('day');
  };

  // componentDidMount(){
  //   if (this.props.usuario && !this.state.llamada) {
  //     console.log("AAAA");
  //     console.log(this.props.usuario);
  //     this.cambiarOrganismo(this.props.usuario.getUsuario.organismo._id);
  //   }
  // }

  cambiarDatos = (idOrganismo, fecha) => {
    // console.log('DATOS: ', idOrganismo, fecha);
    // console.log(
    //   moment(fecha)
    //     .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
    //     .toDate()
    // );

    if (idOrganismo && fecha) {
      this.setState(
        {
          ...this.state,
          idOrganismo: idOrganismo,
          fecha: fecha,
          loading: true,
        },
        () => {
          // console.log('LLAMO CON: ', idOrganismo, fecha.toDate());
          this.props.client
            .query({
              query: getStockEnFecha,
              variables: {
                idOrganismo: idOrganismo,
                fecha: moment(fecha)
                  .set({ hour: 20, minute: 59, second: 59, millisecond: 0 })
                  .toDate(),
              },
              fetchPolicy: 'network-only',
            })
            .then(res => {
              const stock = res.data.getStockEnFecha;

              // console.log('ME LLEGA: ', stock);
              let detalle = [];

              if (stock) {
                detalle = _.orderBy(
                  stock.detalle,
                  ['tipo_sello[valor]'],
                  ['asc']
                );
                // console.log('EL DETALLES ES: ', detalle);
                this.setState({
                  ...this.state,
                  llamada: true,
                  tipo_sellos: detalle,
                  loading: false,
                });
              }
            })
            .catch(err => {
              console.log('Error en la creacion');
              console.log(err);

              Modal.error({
                title: 'Error a la hora de buscar el stock en la base de datos',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });

              this.setState({
                loading: false,
              });
            });
        }
      );
    } else {
      console.log('ERROR, NO HAY ORGANISMO');
    }
  };

  obtenerNombreOrganismo = idOrganismo => {
    let nombre = '';
    let organismo = _.find(this.props.data.getOrganismos, { _id: idOrganismo });
    organismo ? (nombre = organismo.nombre) : (nombre = '');
    return nombre;
  };

  render() {
    const { data, usuario } = this.props;

    // throw new Error('HOLA');
    if (data.loading || !usuario) {
      return <Loading />;
    }

    // if (!data.getUsuario) {
    //   return null;
    // }
    // let usuario = this.props.usuario;

    // console.log('USUARIO: ', usuario.datos.nombre);

    let fGeneracion = moment(new Date()).format('DD/MM/YYYY HH:mm');

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Administracion General</Breadcrumb.Item>
          <Breadcrumb.Item>Stock</Breadcrumb.Item>
          <Breadcrumb.Item>Consultar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <div>
            <h1 style={{ textAlign: 'center', marginTop: 15 }}>
              Administración General
            </h1>
            <h2 style={{ textAlign: 'center', marginTop: 40 }}>
              STOCK AL FINALIZAR EL DIA SELECCIONADO
            </h2>
            <Row>
              <Col span={4} offset={6}>
                <h3 style={{ textAlign: 'center', marginTop: 10 }}>
                  ORGANISMO:
                </h3>
              </Col>
              <Col span={6}>
                <Select
                  style={{ width: 350, marginLeft: 10 }}
                  id="organismos"
                  placeholder="Seleccione el organismo"
                  defaultValue={
                    usuario && usuario.getUsuario
                      ? usuario.getUsuario.organismo._id
                      : null
                  }
                  disabled={
                    usuario &&
                    usuario.getUsuario &&
                    usuario.getUsuario.organismo._id !== '00004'
                  }
                  onSelect={valor => this.cambiarDatos(valor, this.state.fecha)}
                >
                  {this.props.data.getOrganismos &&
                    this.props.data.getOrganismos.map(organismo => (
                      <Select.Option key={organismo._id}>
                        {organismo.nombre}
                      </Select.Option>
                    ))}
                </Select>
              </Col>
            </Row>
            <Row>
              <Col span={4} offset={6}>
                <h3 style={{ textAlign: 'center', marginTop: 10 }}>FECHA:</h3>
              </Col>
              <Col span={6}>
                <DatePicker
                  style={{ width: 350, marginLeft: 10 }}
                  id="fecha"
                  placeholder="Seleccione la fecha"
                  format="DD/MM/YYYY"
                  onChange={fecha =>
                    this.cambiarDatos(this.state.idOrganismo, fecha)
                  }
                  disabledDate={this.disabledDate}
                  // disabled={usuario.getUsuario.organismo._id != "00004"}
                  value={this.state.fecha}
                />
              </Col>
            </Row>

            <h5 style={{ textAlign: 'center', marginTop: 20 }}>
              FECHA DE GENERACION: {fGeneracion}
            </h5>

            <TablaStockDelDia
              loading={this.state.loading}
              tipo_sellos={this.state.tipo_sellos}
            />

            <Row>
              <Col span={8} offset={8}>
                <Button
                  type="primary"
                  style={{ marginTop: 20, marginLeft: '33%' }}
                  onClick={() =>
                    imprimirReporteStockFecha(
                      this.obtenerNombreOrganismo(this.state.idOrganismo),
                      fGeneracion,
                      this.state.tipo_sellos,
                      moment(this.state.fecha).format('DD [de] MMMM [del] YYYY')
                    )
                  }
                >
                  Imprimir Datos
                </Button>
              </Col>
            </Row>
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(VerStockDelDia);
